import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCbvRandomThemeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;}" }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			width: 24,
			height: 24
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 13,
			width: 2,
			height: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 8,
			width: 2,
			height: 3
		}),
		/* @__PURE__ */ _jsx("path", { d: "m14.51,10.83c.57-.83.35-1.97-.02-2.57-.42-.7-1.27-1.26-2.5-1.26-1.48,0-2.48.96-2.86,2.08l1.37.58c.18-.56.62-1.23,1.5-1.23,1.35,0,1.62,1.27,1.14,1.94-.45.64-1.22,1.08-1.63,1.8-.33.58-.26,1.24-.26,1.65h1.52c0-.78.06-.93.18-1.17.33-.6.92-.88,1.56-1.81Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 3,
			width: 3,
			height: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "m18.01,5h.99v1h2v-1c0-1.1-.9-2-2-2h-.99v2Z" }),
		/* @__PURE__ */ _jsx("path", { d: "m12,14.91c-.58,0-1.05.45-1.05,1.04s.47,1.05,1.05,1.05,1.04-.47,1.04-1.05-.45-1.04-1.04-1.04Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 3,
			width: 3,
			height: 2
		}),
		/* @__PURE__ */ _jsx("path", { d: "m19,18v1h-.99v2h.99c1.1,0,2-.9,2-2v-1h-2Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 19,
			y: 8,
			width: 2,
			height: 3
		}),
		/* @__PURE__ */ _jsx("path", { d: "m5,6v-1h1v-2h-1c-1.1,0-2,.9-2,2v1h2Z" }),
		/* @__PURE__ */ _jsx("path", { d: "m6,19h-1v-1h-2v1c0,1.1.9,2,2,2h1v-2Z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 19,
			width: 3,
			height: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19,
			y: 13,
			width: 2,
			height: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 19,
			width: 3,
			height: 2
		})
	]
});
export default SvgCbvRandomThemeIcon;
